//@flow
import React from 'react'
import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css' // optional
import './styles.scss'

export class Celllinie extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {

    }
    this.generateList = this.updateSizes.bind(this)
    this.updateSizes = this.updateSizes.bind(this)
  }

  updateSizes() {
    this.setState({
      isMobile: window.innerWidth < 711
    })
  }
  
  componentDidMount() {
    window.addEventListener('resize', this.updateSizes)
    this.updateSizes()
  }

  render() {

    //prepare list of ddeparture times
    const departs = this.props.departs.split(',')
    const list = departs.map(function (item, index) {
      return '<li>XX:'+item+' Uhr</li>'
    }).join('')
    
    return <div className='celllinie'>
            <Tippy
              content={<div dangerouslySetInnerHTML={this.state.isMobile ? {
                __html:
                '<h3>'+this.props.linie+' Richtung '+this.props.end+'</h3>'
                +'<div >Abfahrtszeiten in '+this.props.start+':</div>'
                + '<ul>'+list+'</ul><div>Fahrzeit: '+this.props.duration+' min</div>'
              } : {
                __html:
                '<h3>'+this.props.linie+' Richtung '+this.props.end+'</h3>'
                +'<div >Abfahrtszeiten in '+this.props.start+':</div>'
                + '<ul>'+list+'</ul>'
              }} />}
              className='tooltip'
              trigger={this.state.isMobile ? 'click' : 'mouseenter'}
              placement={'bottom'}
              offset={[0, 8]}
              theme={this.props.colorMode}
              interactive={true}>
              <span>{this.props.linie}</span>
            </Tippy>
          </div>
  }
}



             